export function getFiltersMock() {
  return [];
}